import React from 'react';

import { Logo } from './../Logo/Logo';
import { InstagramFeed } from './../InstagramFeed/InstagramFeed';

import { Copyright, Column, FooterDiv, Title, InfoDiv, Icon, Info, MapImage, Links, Link, LinkImage } from './styles';

import location from './ubicacion-blanco.png';
import phone from './phone-blanco.png';
import mail from './mensaje-blanco.png';
import map from './map.png';
import mercadoLibre from './mercadoLibre.png';
import grafitiTime from './grafitiTime.png';

export const Footer = () => (
   <FooterDiv id="contacto">
   		<Column first={true}>
   			<Logo width="80%"/>
   			<Copyright>© A lo Venezolano. Todos los derechos reservados. 2020</Copyright>
   		</Column>
   		<Column>
   			<Title>A LO VENEZOLANO</Title>
            <MapImage src={map} alt="Localización A lo Venezolano"/>
   			<InfoDiv>
   				<Icon src={location}/>
   				<Info>
   					Urb. Los Naranjos calle 137 No. 198-10 parcela No.12. San Jose de Tarbes Valencia Edo. Carabobo. Venezuela
   				</Info>
   			</InfoDiv>
   			<InfoDiv>
   				<Icon src={phone}/>
   				<Info>+58-241-8255815 <br/> +58-412-0409332</Info>
   			</InfoDiv>
   			<InfoDiv>
   				<Icon src={mail}/>
   				<Info>
   					alovzolano@gmail.com
   				</Info>
   			</InfoDiv>
            <Links>
               <Link href="https://articulo.mercadolibre.com.ve/MLV-556589458-bolsas-reusables-_JM?searchVariation=50685269765&quantity=1&variation=50685269765#searchVariation=50685269765&position=11&type=item&tracking_id=d2debdf7-b928-4233-bf7a-087d17056a79" target="_blank">
                  <LinkImage alt="A lo venezolano" src={mercadoLibre}/>
               </Link>
               <Link href="http://www.grafitime.com.ve/" target="_blank">
                  <LinkImage alt="A lo venezolano" src={grafitiTime}/>
               </Link>
            </Links>
   		</Column>
         <Column>
            <Title>INSTAGRAM</Title>
            <InstagramFeed/>
         </Column>
   </FooterDiv>
);
